module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"user_grade":"ユーザーグレード","author_grade":"作成者グレード"}}')
  delete Component.options._Ctor
}
